import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayDefaultZeroPipe } from './displayDefaultZero/display-default-zero.pipe';
import { DomeSanitizerUrlPipe } from './dome-sanitizer-url.pipe';
import { HideCardPipe } from './HideCard/hide-card.pipe';
import { SeparationPipe } from './separation/separation.pipe';
import { HoursToDaysPipe } from './hoursToDays/hours-to-days.pipe';
import { NumberNotRoundPipe } from './numberNotRound/number-not-round.pipe';
import { SanitizeHtmlPipe } from './sanitizeHtml/sanitize-html.pipe';
import { CustomDateTimePipe } from './customDateTime/custom-date-time.pipe';
import { ValidateDatePipe } from './validateDate/validate-date.pipe';


@NgModule({
  declarations: [
    DisplayDefaultZeroPipe,
    DomeSanitizerUrlPipe,
    HideCardPipe,
    SeparationPipe,
    HoursToDaysPipe,
    NumberNotRoundPipe,
    SanitizeHtmlPipe,
    CustomDateTimePipe,
    ValidateDatePipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DisplayDefaultZeroPipe,
    DomeSanitizerUrlPipe,
    HideCardPipe,
    SeparationPipe,
    HoursToDaysPipe,
    NumberNotRoundPipe,
    SanitizeHtmlPipe,
    CustomDateTimePipe,
    ValidateDatePipe
  ]
})
export class PipesModule { }
